import styled from 'styled-components';

export const SupportContactCardContent = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ContactItemIcon = styled.div`
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.elevations.low};
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  }
`;

export const ContactItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const ContactItemLink = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  line-height: 20px;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.colors.buttonButtonPrimarySecondary2100};
  }
`;
